<template>
    <header>
        <nav class="navbar fixed-top nav justify-content-center">
            <div class="navbar-brand m-0">
                <HarrodsLogo />
            </div>
        </nav>
    </header>
</template>

<script>
import HarrodsLogo from '@/components/HarrodsLogo.vue'

export default {
  name: 'SiteHeader',
  props: {
    msg: String
  },
  components: {
    HarrodsLogo
  }
}
</script>

<style lang="scss" scoped>
.nav {
    height: 76px;
    width: 100%;
    background-color: $harrods-white;
    border-top: 4px solid $harrods-dark-gold-2;
    border-bottom: 1px solid $light-grey-1;
}
    .navbar-brand {
        margin-top: -2px !important;
    }
</style>
